import React  from 'react';

const DimensionsIcon = () => {

  return <span className="spec-img">
      <svg id="dimensions" xmlns="http://www.w3.org/2000/svg" width="31.278" height="31.278" viewBox="0 0 31.278 31.278">
          <g id="Group_137" data-name="Group 137" transform="translate(0 0)">
              <g id="Group_132" data-name="Group 132">
                  <path id="Path_155" data-name="Path 155" d="M25.512,25.516H28V28H25.516V26.762h0ZM21.065,28h2.485V25.52H21.065Zm-4.448,0H19.1V25.52H16.617Zm-4.448,0h2.485V25.52H12.169ZM28,3.273V0H25.519V3.279H3.27V25.52H0V28H3.274v3.274H5.758V28h4.448V25.52H5.754V5.764H25.512v4.447H28V5.758h3.28V3.273H28Zm-2.492,20.28H28V21.069H25.512Zm0-4.447H28V16.622H25.512Zm0-4.447H28V12.174H25.512Z" fill="#0081ca"/>
              </g>
          </g>
      </svg>
  </span>

}

export default DimensionsIcon;
